@if (multiUpload) {
  <span class="inline">
    <input type="file" class="hidden" (change)="save($event)" [accept]="acceptedFiletypes" multiple #fileUploadMult>
    <button class="bm-btn bm-btn-square" (click)="fileUploadMult.click()">
      <fa-icon [icon]="['far','paperclip']"/>
    </button>
  </span>
} @else {
  <span class="inline">
    <input type="file" class="hidden" (change)="save($event)" [accept]="acceptedFiletypes" #fileUpload>
    <button class="bm-btn bm-btn-square" (click)="fileUpload.click()">
      <fa-icon [icon]="['far','paperclip']"/>
    </button>
  </span>
}

